import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { StickyBook } from "./StickyBook";
import { IntroSplash } from "./IntroSplash";
import { track } from "@/lib/api";

export function SiteLayout({ children }) {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    track("pageview", null, location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    // Safari can restore a cached page mid-scroll (bfcache); always start at the top.
    const onShow = (e) => { if (e.persisted) window.scrollTo({ top: 0, left: 0, behavior: "instant" }); };
    window.addEventListener("pageshow", onShow);
    return () => window.removeEventListener("pageshow", onShow);
  }, []);

  return (
    <div className="min-h-screen bg-ivory">
      {location.pathname === "/" && <IntroSplash />}
      <Nav />
      <main>{children}</main>
      <Footer />
      <StickyBook />
    </div>
  );
}
